export const isElementInViewport = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const { innerHeight } = window;

  return rect.top <= innerHeight && rect.top >= 0 && rect.bottom >= 0;
};
